import React from "react";
import { FormLabel, FormControl, Grid, FormHelperText } from "@mui/material";
import "./style.scss";

const BoxCheckInput = ({ field, formik }) => {
  const showError = field?.listKey
    ? formik?.touched?.[field?.listKey]?.[field?.index]?.[field?.nameKey] &&
      formik?.errors?.[field?.listKey]?.[field?.index]?.[field?.nameKey]
    : formik?.touched?.[field?.name] && formik?.errors?.[field?.name];

  const handleClick = (e, index, option) => {
    if (field?.readonly) return; // prevent clicks if readonly
    field.handleOnChange(e, index, field?.name, field?.options);
  };

  return (
    <FormControl
      component="fieldset"
      fullWidth
      className="boxCheckInputContainer"
    >
      <div className="radio-group-container">
        {field?.label && (
          <FormLabel
            className="form-label"
            sx={{
              color: "#1C252E",
              fontSize: "14px",
              fontWeight: "500",
              lineHeight: "22px",
              display: "block",
              mb: "6px",
            }}
          >
            {field?.label}
            {field?.required && <span className="asteriskColor"> *</span>}
          </FormLabel>
        )}

        {field.grid ? (
          <Grid container spacing={1} sx={{ mb: field?.mb ?? 2 }}>
            {field?.options?.map((option, index) => (
              <Grid
                item
                xs={field?.xsCol}
                sm={field?.smCol}
                md={field?.mdCol}
                lg={field?.lgCol}
                key={option?.value ?? index}
              >
                <button
                  className={`checkBox topSpaceMob ${
                    formik?.values?.[field?.name] === option.value
                      ? "selectedCheckBox"
                      : ""
                  } ${field?.readonly ? "readonly" : ""}`}
                  onClick={(e) => handleClick(e, index, option)}
                  type="button"
                  tabIndex={0}
                  style={{
                    pointerEvents: field?.readonly ? "none" : "auto",
                    opacity: field?.readonly ? 0.7 : 1,
                    cursor: field?.readonly ? "not-allowed" : "pointer",
                  }}
                >
                  <div className="TextCenter">{option.name}</div>
                </button>
              </Grid>
            ))}
          </Grid>
        ) : (
          <div>
            {field?.options?.map((option, index) => (
              <div key={option?.value ?? index}>
                <button
                  className={`checkBox ${
                    formik?.values?.[field?.name] === option?.value
                      ? "selectedCheckBox"
                      : ""
                  } ${field?.readonly ? "readonly" : ""}`}
                  onClick={(e) => handleClick(e, index, option)}
                  type="button"
                  tabIndex={0}
                  style={{
                    pointerEvents: field?.readonly ? "none" : "auto",
                    opacity: field?.readonly ? 0.7 : 1,
                    cursor: field?.readonly ? "not-allowed" : "pointer",
                  }}
                >
                  <div>{option.name}</div>
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      {showError && (
        <FormHelperText
          error
          style={{ marginTop: field?.mb === 0 ? "0px" : "-12px" }}
        >
          {showError}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default BoxCheckInput;
